import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/libros_contables/intercambioCuentas';
import IntercambioForm from './IntercambioCuentas';


const ms2p = (state) => {
  return {
    ...state.lc_intercambioCuenta,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(IntercambioForm);
